import React, {useState} from 'react';
import {CartItemDataHook} from '../../CartItem';
import {useControllerProps} from '../../../../../../domain/controllers/ControllerContext';
import {classes} from '../../CartItem.st.css';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {Delete} from '@wix/wix-ui-icons-common/on-stage';
import {LineItemModel} from '../../../../../../domain/models/LineItems/LineItem.model';
import {RemoveLinkedItemsDialog} from '../../../../RemoveLinkedItemsDialog/RemoveLinkedItemsDialog';

export interface RemoveProps {
  lineItem: LineItemModel;
  onItemRemoved?: () => void;
}

export const Remove = ({lineItem, onItemRemoved}: RemoveProps) => {
  const {t} = useTranslation();
  const {cartModel, removeItemsFromCart} = useControllerProps().cartStore;
  const [isRemovalDialogOpen, setIsRemovalDialogOpen] = useState(false);

  const requiresRemovalConfirmation = lineItem.linkedLineItemIds.length > 0;

  const handleRemoveItem = () => {
    if (requiresRemovalConfirmation) {
      setIsRemovalDialogOpen(true);
      return;
    }
    void removeItemsFromCart([lineItem]);
    onItemRemoved?.();
  };

  const confirmRemoval = () => {
    setIsRemovalDialogOpen(false);
    const linkedLineItems = cartModel.lineItems.filter((item) => lineItem.linkedLineItemIds.includes(item.id));
    void removeItemsFromCart([lineItem, ...linkedLineItems]);
    onItemRemoved?.();
  };

  return (
    <>
      <button
        className={classes.remove}
        type="button"
        aria-label={t('cart.sr_remove_item_from_cart', {item_name: lineItem.name})}
        onClick={handleRemoveItem}
        data-hook={CartItemDataHook.Remove}>
        <Delete />
      </button>
      {isRemovalDialogOpen && (
        <RemoveLinkedItemsDialog onConfirm={confirmRemoval} onCancel={() => setIsRemovalDialogOpen(false)} />
      )}
    </>
  );
};
